"use strict";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

const ViewportSize = {
    small: 'small',
    medium: 'medium',
    large: 'large',
}

class StoryPage {
    constructor() {
        this._scrollTimelines = [];

        this._viewportSize = this._identifyViewportSize();
    }

    initialize() {
        window.onload = () => this._handleWindowLoad();
        window.onresize = () => this._handleWindowResize();
    }

    _identifyViewportSize() {
        const windowWidth = window.innerWidth;
        let viewportSize;

        if (windowWidth < 750) {
            viewportSize = ViewportSize.small;
        } else if (windowWidth < 990) {
            viewportSize = ViewportSize.medium;
        } else {
            viewportSize = ViewportSize.large;
        }

        return viewportSize;
    }

    _handleWindowLoad() {
        // Lenis
        const lenis = new Lenis()
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        // Remove loader
        document.querySelector("#reviewsPage").classList.add("loaded");

        // Initial animation
        gsap.timeline()
            .fromTo('.heroSection', { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 }, "+=0.5");

        // Initialize reviewCard
        this._initializeReviewCards();

        // Initialize scroll ani,ations
        this._initializeScrollTimelines();

    }

    _handleWindowResize() {
        // Re-initialize reviewCard
        this._initializeReviewCards();

        // Reload timelines if window size type changes
        const newViewportSize = this._identifyViewportSize();
        if (newViewportSize != this._viewportSize) {
            this._viewportSize = newViewportSize;
            this._initializeScrollTimelines();
        }
    }

    _initializeReviewCards() {
        const reviewCards = document.querySelectorAll(".reviewCard");
        for (const reviewCardEl of reviewCards) {
            const reviewTextEl = reviewCardEl.querySelector(".reviewText");
            const textEl = reviewTextEl.querySelector(".text");
            const fullTextEl = reviewTextEl.querySelector(".fullText");
            const isExpanded = reviewCardEl.classList.contains("expanded");
            const reviewTextElHeight = isExpanded
                ? fullTextEl.scrollHeight
                : textEl.scrollHeight;
            reviewTextEl.style.height = `${reviewTextElHeight}px`;

            const expandButtonEl = reviewCardEl.querySelector(".reviewExpandButton");
            if (expandButtonEl) {
                reviewCardEl.removeEventListener("click", this._handleReviewExpandButtonClick)
                reviewCardEl.addEventListener("click", this._handleReviewExpandButtonClick);
            }
        }
    }

    _handleReviewExpandButtonClick(event) {
        const reviewCardEl = event.target;
        const reviewTextEl = reviewCardEl.querySelector(".reviewText");
        const isExpanded = reviewCardEl.classList.contains("expanded");
        if (isExpanded) {
            const textEl = reviewTextEl.querySelector(".text");
            const reviewTextElHeight = textEl.scrollHeight;
            reviewTextEl.style.height = `${reviewTextElHeight}px`;
            const onTransitioned = function () {
                reviewCardEl.classList.remove("expanded");
                reviewTextEl.removeEventListener("transitionend", onTransitioned);
            }
            reviewTextEl.addEventListener("transitionend", onTransitioned, false);
        } else {
            reviewCardEl.classList.add("expanded");
            const fullTextEl = reviewTextEl.querySelector(".fullText");
            const reviewTextElHeight = fullTextEl.scrollHeight;
            reviewTextEl.style.height = `${reviewTextElHeight}px`;
        }
    }

    _initializeScrollTimelines() {

        // Kill any existing timelines
        let scrollTriggers = ScrollTrigger.getAll()
        for (const scrollTrigger of scrollTriggers) {
            scrollTrigger.kill(true)
        }
        for (const timeline of this._scrollTimelines) {
            timeline.kill(true);
        }

        // Clear up any previous timelines
        this._scrollTimelines = [];

        // Intilaize animations
        if (this._viewportSize === ViewportSize.small) {
            this._setupScrollTimelinesForSmallViewport();
        } else if (this._viewportSize === ViewportSize.medium) {
            this._setupScrollTimelinesForMediumViewport();
        } else {
            this._setupScrollTimelinesForLargeViewport();
        }

        // Preplay timelines
        this._prePlayTimelines();
    }

    _setupScrollTimelinesForSmallViewport() {
        // 
    }

    _setupScrollTimelinesForMediumViewport() {
        // 
    }

    _setupScrollTimelinesForLargeViewport() {
        const reviewsTimeline = gsap.timeline({
            scrollTrigger: {
                id: `reviewsSectionTimeline`,
                trigger: ".reviewsSection",
                start: 'top 100%',
                end: 'top 0%',
                scrub: 0,
                markers: false,
            }
        })
            .add(
                gsap.timeline()
                    .fromTo(
                        '.heroSection .titles .smallTitle, .heroSection .titles .title',
                        { backgroundPosition: '0%' },
                        { backgroundPosition: '100%', ease: "linear" },
                    )
                    .fromTo(
                        '.heroSection .titles .smallTitle, .heroSection .titles .title',
                        { backgroundPosition: '100%' },
                        { backgroundPosition: '0%', ease: "linear" },
                    ),
                "<"
            )
            .fromTo(
                ".heroSection .titles",
                { scale: 1 },
                { scale: 0.86, duration: 1 },
            )
            .fromTo(
                ".heroSection .arrows",
                { opacity: 1 },
                { opacity: 0, duration: 1 },
                "<"
            )
            .fromTo(
                "#reviewsColumn2",
                { y: "-200%" },
                { y: "0%", ease: "power1.out", duration: 2 },
                "<"
            );
        this._scrollTimelines.push(reviewsTimeline);
    }

    _prePlayTimelines() {
        // Preplay animations to ensure smoothness on animatiing during
        // window scroll. Note that we play animations in reverse order.
        for (let index = this._scrollTimelines.length - 1; index >= 0; index--) {
            const timeline = this._scrollTimelines[index];
            timeline.progress(1).progress(0);
        }
    }
}

const storyPage = new StoryPage();
storyPage.initialize();